import React from 'react';
import { motion } from 'framer-motion';
import { Search, ShieldCheck, Activity, Zap } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-white pt-12 pb-20 overflow-hidden" data-id="element-227">
      {/* Subtle Grid Background */}
      <div className="absolute inset-0 z-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#002E5D 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-228" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10 text-center" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-230">
          <span className="inline-block px-4 py-1.5 bg-federal-blue/5 text-federal-blue text-xs font-bold tracking-widest uppercase rounded-full mb-6 border border-federal-blue/10" data-id="element-231">
            Mission-Critical Infrastructure
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-federal-blue mb-8 leading-[1.1] tracking-tight max-w-5xl mx-auto" data-id="element-232">
            Securing the Federal Mission: <br data-id="element-233" />
            <span className="text-tech-slate" data-id="element-234">
              From Digital Apps to Physical Infrastructure.
            </span>
          </h1>
        </motion.div>
        {/* The Scan Tool */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-3xl mx-auto mt-12" data-id="element-235">
          <div className="bg-white p-2 rounded-lg shadow-2xl border border-slate-200 ring-8 ring-slate-50" data-id="element-236">
            <div className="p-6 md:p-8 text-left" data-id="element-237">
              <h3 className="text-federal-blue font-bold text-lg mb-2 flex items-center gap-2" data-id="element-238">
                <Activity className="w-5 h-5 text-muted-gold" data-id="element-239" />
                Validate Your Agency's Compliance
              </h3>
              <p className="text-tech-slate text-sm mb-6 opacity-80" data-id="element-240">
                Enter a .gov or .mil URL for a quick WCAG 2.1 accessibility &
                performance health assessment.
              </p>
              <div className="flex flex-col md:flex-row gap-3" data-id="element-241">
                <div className="relative flex-grow" data-id="element-242">
                  <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none" data-id="element-243">
                    <Search className="w-5 h-5 text-slate-400" data-id="element-244" />
                  </div>
                  <input type="text" placeholder="agency-portal.gov" className="w-full pl-12 pr-4 py-4 bg-slate-50 border border-slate-200 rounded-md focus:ring-2 focus:ring-federal-blue focus:border-transparent outline-none transition-all font-mono text-sm" data-id="element-245" />
                </div>
                <button className="bg-federal-blue hover:bg-federal-blue/90 text-white px-8 py-4 rounded-md font-bold transition-all flex items-center justify-center gap-2 whitespace-nowrap" data-id="element-246">
                  Run Health Assessment
                  <Zap className="w-4 h-4 text-muted-gold" data-id="element-247" />
                </button>
              </div>
            </div>
            <div className="bg-slate-50 px-8 py-3 border-t border-slate-100 flex flex-wrap gap-6 justify-center text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-248">
              <span className="flex items-center gap-1.5" data-id="element-249">
                <ShieldCheck className="w-3 h-3" data-id="element-250" /> WCAG 2.1 Gaps
              </span>
              <span className="flex items-center gap-1.5" data-id="element-251">
                <ShieldCheck className="w-3 h-3" data-id="element-252" /> Mobile Response
              </span>
              <span className="flex items-center gap-1.5" data-id="element-253">
                <ShieldCheck className="w-3 h-3" data-id="element-254" /> PageSpeed Benchmarks
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}